function Loading() {
	return (
		<div className="loading">
			<div className="content">Loading</div>
		</div>
	);
}

export default Loading;
